import { AppStateProvider } from './../../services/app-state.provider';
import { InviteService } from './../../services/invite.service';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DateService } from 'src/app/services/date.service';
import { Subscription } from 'rxjs';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SidenavService } from 'src/app/services/sidenav.service';
import { RolebasedactionService } from 'src/app/services/rolebasedaction.service';

@Component({
  standalone: false,
  selector: 'app-request-details',
  templateUrl: './request-details.component.html',
  styleUrls: ['./request-details.component.scss']
})
export class RequestDetailsComponent implements OnInit, OnDestroy {
  @ViewChild('contentActivation', { static: false }) content: ElementRef;
  id: string;
  date: any;
  time: any;
  buildingName: string;
  tempDate: any;
  approved: boolean = true;
  fromHistory: boolean;
  data: any;
  private subscriptions = new Subscription();
  closeResult: string;
  processType: boolean;
  statusText: string;
  isLoaded: boolean = false;
  pastRecord: boolean;
  vmsApprove: any;
  vmsReject: any;

  constructor(private appStateSrv: AppStateProvider,
    private activatedRoute: ActivatedRoute, private dateSrv: DateService, private invSrv: InviteService, private modalService: NgbModal,
    private sideNavService: SidenavService, private rolebasedactionService: RolebasedactionService,
  ) { }

  ngOnInit(): void {
    this.vmsApprove = this.rolebasedactionService.checkUserRolePermissionExits('VMS/Bulk Invite:Approve');
    this.vmsReject = this.rolebasedactionService.checkUserRolePermissionExits('VMS/Bulk Invite:Reject');
    if (localStorage.getItem('navigate') == '1') this.fromHistory = true
    if (localStorage.getItem('navigate') == '2') this.fromHistory = false
    this.activatedRoute.queryParams.subscribe((res) => {
      this.id = res.id ? res.id : null;
      this.loadData(this.id);
    });

    const route = {
      index: '4',
      name: 'VMS Approval',
      link: '',
      sub: [
        {
          index: '0',
          name: 'Bulk Invite',
          image: '',
          selectedImage: '',
          link: `/bulk-invite-approval/details?id=${this.id}`,
        },]
    };
    localStorage.setItem('expandNav', 'true');
    this.appStateSrv.setSideNavState(route);
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
    localStorage.removeItem('expandNav')

  }

  loadData(id) {
    this.pastRecord = false
    const data = {
      InvitationID: id,
    };
    this.subscriptions.add(this.invSrv.getInvitationDetail(data).subscribe((res) => {
      this.data = res;
      let invitationStartDate = this.extractDate(res?.mstart);
      let currentDate = this.getCurrentDate();
      if (invitationStartDate >= currentDate) {
        this.pastRecord = false;
      } else {
        if (new Date() > new Date(res.mstart)) {
          this.pastRecord = true;
        } else {
          this.pastRecord = false;
        }
      }
      this.isLoaded = true;
    }))
  }

  extractDate(dateTimeStr) {
    return dateTimeStr.split('T')[0];
  }

  getCurrentDate() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(today.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  compareDates(date1: string, date2: string) {
    // Explicitly split and construct Date objects in UTC
    const d1 = new Date(date1 + "T00:00:00Z");
    const d2 = new Date(date2 + "T00:00:00Z");

    // Compare dates
    return d1 === d2;
  }

  approve() {
    const data = {
      "isApproved": this.processType,
      "invitationId": this.id
    }
    this.subscriptions.add(this.invSrv.approveInvitation(data).subscribe(res => {

      if (res.isValid) {
        this.loadData(this.id);
      }
    }))
  }

  formatDate(date, type) {
    if (date == null) return;
    if (type == 'date') {
      this.tempDate = date.split('T')[0].split('-');
      return this.dateSrv.convertDateToLocaleString(this.tempDate[2], this.tempDate[1] - 1, this.tempDate[0]);
    }
    if (type == 'time') {
      this.tempDate = date.split('T')[1].split(':');
      if (this.tempDate[0] == 12) {
        return this.tempDate[0] + ':' + this.tempDate[1] + ' ' + 'PM'
      }
      else {
        return this.tempDate[0] > 12 ? this.tempDate[0] - 12 + ':' + this.tempDate[1] + ' ' + 'PM' : this.tempDate[0] + ':' + this.tempDate[1] + ' ' + 'AM';
      }
      // return this.tempDate[0]>12? this.tempDate[0]-12 + ':' + this.tempDate[1] +' '+ 'PM':this.tempDate[0]+ ':' + this.tempDate[1] +' '+ 'AM';
    }
  }

  openModal(type) {
    this.processType = (type == 'true') ? true : false
    this.statusText = (type == 'true') ? 'Approve' : 'Reject'
    this.open(this.content);
  }

  open(content) {
    this.modalService
      .open(content, {
        ariaLabelledBy: 'modal-basic-title',
        centered: true,
        windowClass: 'custom-class',
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
}
